<template>
    <div v-if="subscription">
        <div v-if="!isActive" class="h-3"></div>

        <bumper-box-upgrade v-if="bumperBoxEnabled && subscription.product_family !== bumperBox"/>

        <coupon-history :customStyles="{ padding: '25px 0', margin: '0', }" />

        <div class="divider--container background--paper clear--sm">
            <div class="divider-white--top"></div>
            <div class="divider-white--bottom"></div>
        </div>

        <delivery-schedule-address
            v-if="showDropdown"
            :show-dropdown="showDropdown"
            :address="address"
            address-class="pt-1 px-4"/>
        <div v-else class="h-1 lg:h-2"></div>

        <div class="container mx-auto text-center max-w-xs pt-4">
            <div class="deliveryAddressCard__container">
                <div
                    v-if="!showEditForm"
                    class="accordion__sm--no-scroll accordion__sm accordion__sm--active">
                    <!-- Pause -->
                    <!-- <pause-button v-if="pauseAllowed || isAccountPaused" :subscription="subscription" @toggleCantPauseModal="toggleCantPauseModal"/> -->

                    <!-- Quantity -->
                    <address-manage-quantity
                        v-if="isActive"
                        :subscription="subscription"
                        :label="$t('MANAGE_DELIVERY_BOXES_PER')"/>

                    <select-box-type v-if="bumperBoxEnabled" :subscription="subscription"/>

                    <delivery-price headingKey="MANAGE_DELIVERY_COST_EACH" v-if="subscriptionsPrice" :price="subscriptionsPrice"/>

                    <delivery-price-strike v-if="deliveryPrice" headingKey="MANAGE_DELIVERY_PRICE" :actualPrice="deliveryPrice" :discountedPrice="discountedDeliveryPrice"/>

                    <!-- Change Plan -->
                    <div v-if="changePlanEnabled" class="deliveryAddressCard__action edit-option" @click="openModal()">
                        <p v-if="!loading && offeredPlan" class="no-margin" v-text="$t('MANAGE_DELIVERY_PLAN', { planName: offeredPlan.name })"></p>
                        <i v-if="loading" class="loader__loading-icon fa-spin"/>
                        <font-awesome-icon class="spinner" icon="exchange-alt"/>
                    </div>

                    <!-- <modal v-if="modalOpen" :allowCancel="false" custom-class="max-w-sm" @closed="closeModal()">
                        <div class="shift-delivery-modal" >
                            <div class="shift-delivery-content">
                                <p v-html="$t('SHIFT_DELIVERY_PLAN_SUCCESS', { plan: offeredPlan.name })"></p>
                                <p><strong>{{formatSelectedNextDeliveryDate}}</strong></p>
                                <button
                                    type="button"
                                    class="btn btn--primary btn--half"
                                    @click="updatePlan()"
                                    v-text="$t('SHIFT_DELIVERY_SAVE')">
                                </button>
                            </div>
                        </div>
                    </modal> -->

                    <modal v-if="modalOpen" :allowCancel="false" custom-class="max-w-sm" @closed="closeModal()">
                        <div class="shift-delivery-modal" >
                            <div class="shift-delivery-content">
                                <p v-html="$t('SHIFT_DELIVERY_PLAN', { plan: offeredPlan.name })"></p>
                                <p v-html="$t('SHIFT_DELIVERY_PLAN_START_DATE', { plan: offeredPlan.name })"></p>
                                <div class="dropdown">
                                    <Dropdown
                                        v-model="selectedNextDelivery"
                                        :inputStyle="'border-color: black;'"
                                        :track-by="'human'"
                                        :label="'human'"
                                        :placeholder="'Choose a delivery date'"
                                        :items="allowedDeliveries" />
                                </div>
                                <button
                                    type="button"
                                    class="btn btn--primary btn--half"
                                    @click="updatePlan()"
                                    v-text="$t('SHIFT_DELIVERY_SAVE')">
                                </button>
                            </div>
                        </div>
                    </modal>

                    <!-- Edit address -->
                    <div v-if="isActive" class="deliveryAddressCard__action edit-option" @click="toggleEditForm">
                        <p class="no-margin" v-text="$t('MANAGE_DELIVERY_EDIT')"></p>
                        <img class="edit-option__icon" src="@/assets/images/decoration/arrow-right-black.svg">
                    </div>

                    <!-- Opt-Out-Amerylily -->
                    <div v-if="showAmarylilyOptOut" class="deliveryAddressCard__action edit-option" @click="handleUpdatingAmaryllisOptOutApi">
                        <p class="no-margin" v-text="$t('MANAGE_DELIVERY_OPTOUT')"></p>
                        <img class="edit-option__icon" src="@/assets/images/decoration/arrow-right-black.svg">
                    </div>

                    <!-- charity price -->
                    <div v-if="isCharityEnable" class="deliveryAddressCard__action deliveryAddressCard__action--no-underline edit-option">
                        <input class="iconBox" type="checkbox" v-model="charity" @click.prevent="doNotUpdate"/>
                            <p class="no-margin"><strong>{{$t('FREDDIES_DONATION_1')}}</strong> {{$t('FREDDIES_DONATION_2')}} <span class="learn-more" v-text="$t('FREDDIES_LEARN')" @click="toggleTerms"/></p>
                    </div>

                    <!-- Cancel -->
                    <div class="deliveryAddressCard__action cancel-option" v-if="allowCancel" @click="toggleCancelModal">
                        <p class="no-margin" v-text="$t('MANAGE_DELIVERY_CANCEL')"></p>
                        <img class="cancel-option__icon" src="@/assets/images/decoration/nav-close.svg">
                    </div>
                </div>
                <edit-delivery-address-form
                    v-if="showEditForm"
                    :subscription-id="subscription.id"
                    :address="address"
                    :delivery-comment="subscription.delivery_comment"
                    :property-type="address.property_type"
                    @subscription-address-updated="addressUpdated"
                    @closed="toggleEditForm"/>
            </div>
            <p v-if="isCharityEnable" class="charity-info" v-text="$t('FREDDIES_CHARITY_CANCEL')"></p>
        </div>

        <charity-price-modal v-if="isCharity" @closed="toggleCharity" :subscription-id="subscription.id"/>
        <charity-terms-modal v-if="isterms" @closed="toggleTerms"/>

        <opt-out-amerally-modal v-if="showOptOutModal" @closed="optOutModal"/>

        <pause-deliveries-confirmation-modal @pause-deliveries-modal-closed="handleConfirmationModalClosed" :subscription-id="subscription.id" v-if="showPauseConfirmationModal" />

        <cancel-subscription-modal
            v-if="showCancelModal"
            :subscription-id="subscription.id"
            @cancelled="handleSubscriptionCancelled"
            @closed="toggleCancelModal"/>

        <cannot-pause-modal v-if="showCantPauseModal" :isPause="true"/>

        <floating-banner/>
    </div>
</template>

<script>
import { Dropdown } from '@freddiesflowers/frontend-component-library';
import { mapGetters } from 'vuex';
import { formatDate } from '@/helpers/DateHelpers';
import * as Dates from '@/constants/Dates';
import { SUBSCRIPTION_STATUS_ACTIVE, SUBSCRIPTION_STATUS_PAUSED } from '@/constants/Subscription';
import Modal from '@/components/structure/Modal';
import CancelSubscriptionModal from '@/components/modals/CancelSubscriptionModal';
import PauseDeliveriesConfirmationModal from '@/components/modals/PauseDeliveriesConfirmationModal';
import EditDeliveryAddressForm from '@/components/forms/addresses/EditDeliveryAddressForm';
import DeliveryPrice from '@/components/partials/account/my-delivery-addresses/DeliveryPrice';
import DeliveryPriceStrike from '@/components/partials/account/my-delivery-addresses/DeliveryPriceStrike';
import AddressManageQuantity from '@/components/partials/account/my-delivery-addresses/AddressManageQuantity';
import DeliveryScheduleAddress from '@/components/partials/account/my-delivery-schedule/DeliveryScheduleAddress';
import PauseButton from '../my-delivery-addresses/PauseButton.vue';
import SelectBoxType from '@/components/partials/account/my-delivery-addresses/SelectBoxType';
import SubscriptionService from '@/services/subscriptions/SubscriptionService';
import BumperBoxUpgrade from '@/components/partials/account/bumper-box/BumperBoxUpgrade';
import { PRODUCT_FAMILY_BUMPER } from '@/constants/Gifting';
import CharityTermsModal from '@/components/modals/CharityTermsModal';
import CharityPriceModal from '@/components/modals/CharityPriceModal';
import CouponHistory from '../coupon-history/CouponHistory.vue';
import { CSPageEvents } from '@/helpers/GAHelpers';
import CannotPauseModal from '@/components/modals/CannotPauseModal';
import FloatingBanner from '@/components/structure/FloatingBanner.vue';
import UserService from '@/services/users/UserService';
import OptOutAmerallyModal from '@/components/modals/OptOutAmerallyModal';
import { LILY_FAMILY_OPT_OUT } from '@/constants/Features';

let subscriptionService = new SubscriptionService();

export default {
    name: 'ManageDelivery',
    components: {
        DeliveryPrice,
        DeliveryPriceStrike,
        DeliveryScheduleAddress,
        Dropdown,
        PauseDeliveriesConfirmationModal,
        AddressManageQuantity,
        CancelSubscriptionModal,
        EditDeliveryAddressForm,
        SelectBoxType,
        // PauseButton,
        BumperBoxUpgrade,
        Modal,
        CharityPriceModal,
        CharityTermsModal,
        CouponHistory,
        CannotPauseModal,
        FloatingBanner,
        OptOutAmerallyModal,
    },
    props: {
        showDropdown: {
            required: true,
            type: Boolean,
        },
    },
    data() {
        return {
            showEditForm: false,
            showCancelModal: false,
            showPauseConfirmationModal: false,
            loading: false,
            modalOpen: false,
            selectedNextDelivery: null,
            bumperBox: PRODUCT_FAMILY_BUMPER,
            schedulePlanChange: true,
            isCharity: false,
            isterms: false,
            showCantPauseModal: false,
            showOptOutModal: false,
        };
    },
    computed: {
        ...mapGetters({
            activeSubscriptions: 'subscription/getActiveSubscriptions',
            subscription: 'subscription/getActiveSubscription',
            allowCancel: 'subscription/allowCancel',
            changePlanEnabled: 'account/getSkipConsecutiveHolidayEnabled',
            bumperBoxEnabled: 'account/getBumperBoxEnabled',
            deliveries: 'scheduledOrder/getDeliveries',
            plans: 'cms/getPlans',
            pauseAllowed: 'account/getAllowPaused',
            userId: 'account/getUserId',
            showAmarylilyOptOut: 'account/getLilyFamilyOptOutEnabled',
        }),
        isBumper() {
            return this.subscription.product_family === this.bumperBox;
        },
        isCharityEnable() {
            return process.env.VUE_APP_ENABLE_CHARITY_PRICE === 'true';
        },
        offeredPlan() {
            const weeklyPlan = this.plans.find((item) => item.slug === 'weekly');
            const fortnightlyPlan = this.plans.find((item) => item.slug === 'fortnightly');

            return this.subscription && this.subscription.plan_slug === 'weekly' ? fortnightlyPlan : weeklyPlan;
        },
        address() {
            return this.subscription && this.$store.getters['address/getAddressById']
                ? this.$store.getters['address/getAddressById'](this.subscription.delivery_address_id)
                : {};
        },
        allowedDeliveries() {
            return this.deliveries.filter((item) => !item.is_locked && !item.scheduled_order_id)
                .map((item) => {
                    item.human = formatDate(new Date(item.datetime), Dates.DAY_DATE_MONTH_YEAR);
                    return item;
                });
        },
        subscriptionsPrice() {
            return this.subscription?.price || 0;
        },
        deliveryPrice() {
            return this.subscription?.delivery_amount;
        },
        discountedDeliveryPrice() {
            return this.subscription?.discounted_delivery_amount || 0;
        },
        isActive() {
            return this.subscription && this.subscription.status === SUBSCRIPTION_STATUS_ACTIVE;
        },

        formatSelectedNextDeliveryDate() {
            return formatDate(new Date(this.allowedDeliveries[0].datetime), Dates.DAY_DATE_MONTH_YEAR);
        },

        hasCharity() {
            return this.subscription?.opt_in_charity_price;
        },

        charity: {
            get() {
                return this.isCharity || this.hasCharity;
            },
            set(value) {
                return this.isCharity = !this.isCharity;
            },
        },

        isAccountPaused() {
            return this.subscription.status === SUBSCRIPTION_STATUS_PAUSED;
        },
    },
    methods: {
        doNotUpdate(event) {
            this.toggleCharity();
            if (event && this.hasCharity) {
                event.preventDefault();
            }
        },

        optOutModal() {
            this.showOptOutModal = !this.showOptOutModal;
        },
        openModal() {
            this.modalOpen = true;
            this.selectedNextDelivery = this.allowedDeliveries[0] || null;
        },

        closeModal() {
            this.modalOpen = false;
        },

        updatePlan() {
            this.closeModal();

            if (!this.loading) {
                this.loading = true;
                CSPageEvents(`plan-switched-to-${this.offeredPlan.slug}`);
                subscriptionService.updateSubscriptionPlan(this.subscription.id, this.offeredPlan.slug, this.selectedNextDelivery.datetime, this.schedulePlanChange).then(() => {
                    this.$store.dispatch('subscription/fetchAllSubscriptions', true);
                    this.$store.dispatch('scheduledOrder/fetchAllDeliveries', true);
                    this.loading = false;
                    this.$scrollTo('body');
                }).catch(error => console.log(error.response.data));
            }
        },

        handleChanged() {
            this.$emit('changed');
        },

        handleDeliveriesPaused() {
            this.$emit('paused');
            this.showPauseConfirmationModal = true;
        },

        handleDeliveriesResumed() {
            this.$emit('resumed');
            this.showPauseConfirmationModal = false;
        },

        handleConfirmationModalClosed() {
            this.showPauseConfirmationModal = false;
        },

        handleSubscriptionCancelled(subscriptionId) {
            // we're setting the new active subscription here, because we want to reload scheduled orders
            // for the new active subscription before the request in Vuex (subscription module) will be finished
            let subscription = this.activeSubscriptions.filter(subscription => subscription.id !== subscriptionId)[0];
            this.$store.commit('subscription/setActiveSubscriptionId', subscription.id);

            this.$emit('changed');
        },

        toggleCancelModal() {
            this.showCancelModal = !this.showCancelModal;
        },

        toggleEditForm() {
            this.showEditForm = !this.showEditForm;
        },

        addressUpdated() {
            this.$emit('changed');
            this.$store.dispatch('scheduledOrder/fetchAllDeliveries', true);
        },

        toggleCharity() {
            this.isCharity = !this.isCharity;
        },

        toggleTerms() {
            return this.isterms = !this.isterms;
        },

        toggleCantPauseModal() {
            this.showCantPauseModal = !this.showCantPauseModal;
        },
        handleUpdatingAmaryllisOptOutApi() {
            let userService = new UserService();

            userService.updateFeature(this.userId, { feature: LILY_FAMILY_OPT_OUT })
                .then(() => {
                    this.showOptOutModal = !this.showOptOutModal;
                    this.$store.dispatch('account/fetchUserData', true);
                })
                .catch(error => this.errorHandler.setResponse(error.response.data));
        },
    },
};
</script>

<style lang="scss" scoped>
.cancel-option {
    padding-right: 21px;
}

.cancel-option__icon {
    max-width: 20px;
    max-height: 20px;
}

.edit-option {
    padding-right: 24px;
    border-top: 1px solid black;
}

.edit-option__icon {
    max-width: 25px;
    max-height: 25px;
}

.loader__loading-icon {
    width: 30px;
    height: 30px;
}

.shift-delivery-modal {
    text-align: center;

    button {
        margin: 12px 8px 0px 8px;
    }
}
.iconBox {
    box-sizing: inherit;
    margin-top: -1px;
    padding-right: 0rem;
    padding-left: 1rem;
    width: 25px;
    height: 25px;
    accent-color: gray;
}
.charity-info {
    font-family: Gill Sans;
    font-size: 13px;
    font-weight: 300;
    line-height: 20px;
    letter-spacing: 0em;
    text-align: justify;
    height: 72px;
}

.learn-more {
    text-decoration: underline;
    cursor: pointer;
}
</style>
